import React from "react";
import Mixed from 'components/custom/Highcharts/Mixed'
import T from 'i18n-react'
import { Link } from 'react-router-dom'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from '../styles.scss'
import { compose } from 'recompose'
import { chartStateSelector } from '../selectors'
import { onThermalChartTypeToggle, updateThermalSelectedPoint } from '../actions'
import { Flex } from 'reflexbox'
import { Checkbox } from 'react-toolbox/lib/checkbox'
import { connect } from 'react-redux'
import { Table, TableCell, TableRow, TableHead } from 'react-toolbox/lib/table'
import LoadingDiv from '../LoadingDiv.jsx'

const mapStateToProps = (state) => {
  return {
    chartState: chartStateSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleChartFilter: (chartType, category) => dispatch(onThermalChartTypeToggle(chartType, category)),
    updatePointSelect: (chartType, projectId) => dispatch(updateThermalSelectedPoint(chartType, projectId))
  }
}

class ThermalCard extends React.Component {

  updateSelectedPoint = (event) => {
    const { report } = this.props
    this.props.updatePointSelect(report.type, event.point.projectId)
  }

  getAdditionalOptions = () => {
    
    return {
      plotOptions: {
        series: {
          cursor: 'pointer',
          events: {
              click: (event) => {
                if (event.point.x == null) return
                this.updateSelectedPoint(event)
              }
          }
      }
      },
    }

  }

  renderDetailsTable = () => {
    const { chartState, report } = this.props
    if (!report || !report.type) return
    const { selectedPoint } = chartState(report.type)
    if (selectedPoint == null) return
    const selectedProject = report.additionalInfo.find(x => x.projectId == selectedPoint)
    return (
      <Table selectable={false}>
        <TableHead>
        <TableCell idx={`head1`}>Project ID</TableCell>
        <TableCell idx={`head2`}>Project Name</TableCell>
        <TableCell idx={`head3`}>NVQual Revision #</TableCell>
        <TableCell idx={`head4`}>Product SKU</TableCell>
        <TableCell idx={`head5`}>Partner Site</TableCell>
        </TableHead>
        <TableRow idx={`1`}>
          <TableCell idx={`11`}><Link to={`/project/${selectedProject.projectId}/view`} target="_blank">{selectedProject.projectId}</Link></TableCell>
          <TableCell idx={`12`}>{selectedProject.projectName}</TableCell>
          <TableCell idx={`13`}>{selectedProject.revisionNumber}</TableCell>
          <TableCell idx={`14`}>{selectedProject.productSku}</TableCell>
          <TableCell idx={`15`}>{selectedProject.partnerSiteName}</TableCell>
        </TableRow>
      </Table>
    )
  }

  renderFilters = () => {
    const { chartState, toggleChartFilter, report } = this.props
    const { max, avg } = chartState(report.type)
    return (
      <Flex row='true' wrap>
        <Checkbox
          styleName='checkboxes'
          key={'max'}
          label={T.translate(`containers.report.nvqual.thermalCharts.maxCheckbox`)}
          checked={max}
          onChange={toggleChartFilter.bind(this, report.type, 'max')}
        />
        <Checkbox
          styleName='checkboxes'
          key={'avg'}
          label={T.translate(`containers.report.nvqual.thermalCharts.avgCheckbox`)}
          checked={avg}
          onChange={toggleChartFilter.bind(this, report.type, 'avg')}
        />
      </Flex>
    )
  }


  getOneSelectedPrepData = (onlyMaxSelected) => {
    const { report } = this.props
    let prepData = {}
    prepData.category = [...new Set(report.data.map(x => x.projectId))].sort((a,b) => a - b)
    prepData.data = prepData.category.map(x => ({
      type: 'scatter',
      name: x,
      data: report.data.filter(rd => rd.projectId == x)
      .map(rd => ({x : prepData.category.indexOf(rd.projectId),
        y: onlyMaxSelected ? rd.max : rd.avg,
        projectId: rd.projectId,
        deviceName: rd.name
        }))
    }))
    if (report.tempThresholds) 
      prepData.data = prepData.data.concat(report.tempThresholds.map((t, i) => ({
        type: 'line',
        name: `Temperature threshold (${t}\u00B0C)`,
        data: [{x: 0, y: t}, {x: prepData.category.length - 1, y: t}],
        visible: true,
        marker: {
          enabled: false
        }})))
    
    prepData.xTitle = 'Project ID'
    prepData.yTitle = T.translate(`containers.report.nvqual.thermalCharts.yAxis.${report.type}`) 
    return prepData
  }

  renderChart = () => {
    const { chartState, report } = this.props
    const { max, avg } = chartState(report.type)
    let prepData = { data: [] }
    if ( ( max || avg ) && !( max && avg ) ) {
      prepData = max ? this.getOneSelectedPrepData(true) : this.getOneSelectedPrepData(false)
    }

    prepData.title = T.translate(`containers.report.nvqual.chartTitles.${report.type}`)

    return (
      <Mixed 
      title={prepData.title} 
      data={prepData.data}
      categories={prepData.category}
      xTitle={prepData.xTitle}
      yTitle={prepData.yTitle}
      additionalOptions={this.getAdditionalOptions()}/>
    )
  }

  render() {
    const {
      report,
      chartState
    } = this.props

    if (!report || !report.type) return(<div></div>)

    const { chartLoading } = chartState(report.type)

    if (chartLoading) return (<LoadingDiv />)

    return (
      <div>
        { this.renderChart()}
        { this.renderFilters() }
        { this.renderDetailsTable() }
      </div>
    );
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withConnect,
  withStyle,
)(ThermalCard)